<template>
  <div class="basic-form">
    <div class="image" :style="{ 'background-image': `url(${categoryThumbnail})` }" v-show="categories.length > 0"/>
    <div class="form-wrapper">
      <form class="form" @submit.prevent="onSubmit">
        <h2 class="title">
          Super schnell & einfach überall in deiner Nähe
        </h2>
        <div class="form-group">
          <!-- <Dropdown 
            :data="categories_options" 
            placeholder="Anlass wählen"
            required
          /> -->
          <div class="dropdown-wrapper has-icon">
            <select 
              v-model="category"
              class="dropdown" 
              required
            >
              <option value="">
                Anlass wählen
              </option>
              <option 
                v-for="(option, i) in categories" 
                :key="i" 
                :value="option.value"
              >
                {{ option.name }}
              </option>
            </select>
            <span class="icon">
              <font-awesome-icon icon="fa-solid fa-camera" />
            </span>
          </div>

          <div class="position-relative has-icon">
            <input v-model="zipCity" type="text" placeholder="PLZ oder Ort" class="required" required @blur="$options.methods.checkFormCompletition($event)">
            <div class="icon">
              <font-awesome-icon icon="fa-solid fa-location-dot" />
            </div>
            <div class="error-hint">Pflichtfeld</div>
          </div>
        </div>
        <Button type="submit">
          Weiter
        </Button>
      </form>
    </div>
  </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from 'vuex'
import Button from '@/components/ux/Button.vue'
export default {
    name: "BasicForm",
    components: {
        Button,
    },
    data() {
      return {
        categoryThumbnail: ''
      }
    },
    computed: {
        ...mapGetters('orders', [
          "fetching",
          "fetchingErrorCode",
          "fetchingError",
          'categories', 'location', 'selected_category', 'randomCategoryThumbnail']),
        zipCity: {
          get() {
            return this.location.zipCity;
          },
          set(value) {
            this.$store.dispatch("orders/determineLocation", {
              zipCity: value,
              fetching: false
            });
          },
        },
        category: {
            get() {
              return this.selected_category;
            },
            set(value) {
              this.$store.commit("orders/updateCategoriesSelection", {
                categories_id: value
              });
            }
        },
    },
    watch: {
      selected_category: function(val) {
        const category = this.categories.filter(c => c.value == val).slice(0,1).shift();
        if (!category) {
          this.categoryThumbnail = this.randomCategoryThumbnail;
        } else {
          this.categoryThumbnail = category.thumbnail_url
        }
      }
    },
    mounted() {
      this.setRandomThumbnail();
    },
    methods: {
      ...mapActions('orders', ['navigate']),
      setRandomThumbnail() {
        if (!this.randomCategoryThumbnail) {
          setTimeout(() => {
            if(this.selected_category > 0) {
              this.$store.commit("orders/updateCategoriesSelection", {categories_id: this.selected_category});
            } else {
              this.setRandomThumbnail()
            }
          }, 300);
        } else {
          this.categoryThumbnail = this.randomCategoryThumbnail;
        }
      },
      onSubmit(e) {
        if (!this.location.zip || !this.location.city) {
          this.$store.dispatch("orders/determineLocation", {
            zipCity: this.zipCity,
            fetching: true
          });
        }
          this.$options.methods.scrollTop();
          this.$options.methods.goToPath({name: 'Articles', step: 2});
      }
    }
}
</script>

<style lang="scss" scoped>
.basic-form {
    border: 0;
}

.image {
    display: none;
    height: 400px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    flex: 0 0 50%;
}

.form-wrapper {
    flex: 0 0 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.form-group {
  margin-top: 30px;
  margin-bottom: 15px;
}

.form {
    max-width: 345px;
}

@media (min-width: 768px) {
    .image {
        display: flex;
    }

    .form-wrapper {
        // display: block;
    }

    .basic-form {
        display: flex;
        border: 1px solid $border-color;
    }
}
</style>
